import { APIService } from "../../../../../../../../network/api/APIService";

export const PaymentMethodData = async ({ method = "DELETE", id = null, formData = null }) => {
    let endpoint = "/affiliate/payout/payment-methods/item/";
    let query = {};


    if (id) {
        query.id = id;
    }

    const config = {
        endpoint,
        method,
        data: method === "POST" ? formData : null,
        query: Object.keys(query).length ? query : null,
    };

    return await APIService(config);
};